export const SelectDevice = () => {
  return null;
};
